export default __webpack_public_path__ + "static/media/feel-the-luxury.526902ab.webp";